import { STUDIO_BOT } from '@/constants/blockchain'

import { CustomError } from './helpers'
import { post } from './utils'

// Content types
export type ContentType =
  | 'items'
  | 'creators'
  | 'collections'
  | 'collection_items'
  | 'user_published'
  | 'user_owned'
  | 'user_earned' // not used in spaces server

// Request / Response types

// Get hidden items (unauthenticated)

// POST /content/hidden

type HiddenRequest = {
  contentType: ContentType // only for user_published and user_owned
  address: string
}

type HiddenResponse = {
  valid: boolean
  hidden: string[]
  error?: string
}

// Curate content (authenticated)

// POST /content/curate

type CurateRequest = {
  contentType: ContentType
  contentId: string
  hide: boolean
}

type CurateResponse = {
  valid: boolean
  error?: string
}

export const fetchHiddenItems = async (
  contentType: ContentType,
  address: string = ''
): Promise<[string[], CustomError]> => {
  try {
    const req: HiddenRequest = { contentType, address }
    const retval = (await post(
      `${STUDIO_BOT}/content/hidden`,
      JSON.stringify(req)
    )) as HiddenResponse
    if (!retval.valid) {
      return [
        [],
        {
          call: 'content.hidden',
          msg: retval.error || 'Error fetching hidden items',
          isError: true,
        },
      ]
    }
    return [retval.hidden, { call: '', msg: undefined, isError: false }]
  } catch (err: any) {
    return [[], { call: 'content.hidden', msg: err.message, isError: true }]
  }
}

export const curateContent = async (
  token: string,
  contentType: ContentType,
  contentId: string,
  hide: boolean
): Promise<[boolean, CustomError]> => {
  try {
    const req: CurateRequest = { contentType, contentId, hide }
    const retval = (await post(
      `${STUDIO_BOT}/content/curate`,
      JSON.stringify(req),
      token
    )) as CurateResponse

    if (!retval.valid) {
      return [
        false,
        { call: 'content.curate', msg: retval.error || 'Error curating content', isError: true },
      ]
    }
    return [true, { call: '', msg: undefined, isError: false }]
  } catch (err: any) {
    return [false, { call: 'content.curate', msg: err.message, isError: true }]
  }
}
